import firebase from 'src/firebase/firebase'

// Enlace al chat del usuario con el asistente de Google Chat, o null si aún no se ha creado.
export const getAssistantChatUri = async (userId: string): Promise<string | null> => {
  const snap = await firebase.db.collection('whatsappUsers').doc(userId).get()
  const data = snap.data()
  return data?.chatActive && data?.chatUri ? data.chatUri : null
}

// La function abre el chat la primera vez (dejando la bienvenida dentro) y devuelve el enlace.
export const openAssistantChat = async (): Promise<string> => {
  const openAssistantChatCloud = firebase.functions.httpsCallable('openAssistantChat')
  try {
    const result = await openAssistantChatCloud()
    return result.data.chatUri
  } catch (error) {
    console.log(error)
    throw new Error('Hubo un error mientras se intentaba abrir el chat con el asistente')
  }
}
